import React, { useEffect, useState } from "react";
import PageHeader from "./components/PageHeader";
import LeftMenu from "./components/LeftMenu";
import { COLOR_GRAY_BANNER_BACKGROUND } from "../constants/general-constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import db from "../constants/db";
import CircularProgress from "@mui/material/CircularProgress";
import { functions } from "../constants/common-functions";
import {JWT} from "../constants/local-storage";

export default function Administration() {
  const history = useHistory();

  const [fileLocation, setFileLocation] = useState("https://www.claydenallenby.com/");
  const [displayDownloadInfo, setDisplayDownloadInfo] = useState("none");
  const [displayDownloadProgress, setDisplayDownloadProgress] = useState("none");
  const [displayDownloadComplete, setDisplayDownloadComplete] = useState("none");
  const [displayUploadComplete, setDisplayUploadComplete] = useState("none");

  const thisContainer = { display: "flex", flexDirection: "column", width: "100vw", height:'100vh' };
  const buttonContainer = { display: "flex", margin: "auto", marginTop: "17vh", flexDirection: "column" };
  const buttonPanel = { display: "flex", width: "200px", height: "200px", flexDirection: "column", boxShadow: "0 3px 6px rgba(0,0,0,0.08)", borderRadius: "5px", cursor: "pointer", backgroundColor: "white", margin: "10px" };
  const buttonIcon = { display: "flex", width: "60px", height: "60px", marginTop: "35px", alignSelf: "center", color: COLOR_GRAY_BANNER_BACKGROUND };
  const buttonColorBar = { display: "flex", width: "calc(100% - 40px)", marginLeft: "20px", marginRight: "20px", height: "10px", borderRadius: "5px", marginTop: "20px" };
  const buttonTitle = { display: "flex", alignSelf: "center", marginTop: "20px", color: COLOR_GRAY_BANNER_BACKGROUND, fontSize: "16px" };

  const warningContainer = { display: "flex", position: "fixed", left: "0px", right: "0px", bottom: "0px", top: "0px", alignItems: "center", justifyContent: "space-around", backgroundColor: "rgba(0,0,0,0.9)" };
  const warningPanel = { display: "flex", width: "500px", height: "200px", backgroundColor: "white", borderRadius: "10px", alignItems: "center" };
  const warningIcon = { display: "flex", marginLeft: "50px", color: "darkred", width: "60px", height: "60px" };
  const warningText = { display: "flex", marginLeft: "75px", color: COLOR_GRAY_BANNER_BACKGROUND, fontSize: "21px" };
  const spinnerContainer = { display: "flex", width: "100%", height: "auto", alignItems: "center", justifyContent: "space-around", color: "#fff" };
  const warningContentRight = { display: "flex", flexDirection: "column", flexGrow: "1" };
  const warningButtonContainer = { display: "flex", alignSelf: "center", marginTop: "10px" };
  const warningButton = { display: "flex", backgroundColor: "darkred", height: "40px", margin: "10px", borderRadius: "10px", alignItems: "center", justifyContent: "center", fontSize: "14px", color: "white", width: "100px" };

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      setFileLocation("/images/");
    }
  }, []);

  const goClear = async () => {
    
    await db.projects.clear();
    await db.buildings.clear();
    await db.floors.clear();
    await db.times.clear();
    await db.workplaceTypes.clear();
    await db.activities.clear();
    await db.workplaces.clear();
    
  };

  const downloadProgress = () => {
    setDisplayDownloadComplete("flex");
    setDisplayDownloadProgress("none");
    setTimeout(downloadComplete, 2000);
  };

  const downloadComplete = () => {
    setDisplayDownloadInfo("none");
    setDisplayDownloadComplete("none");
	setDisplayUploadComplete("none");
  };

  const goDownload = async () => {
    setDisplayDownloadInfo("flex");
    setDisplayDownloadProgress("flex");

   	functions.getObjectFromAjax("/resolutionsoftwareplatform/survey/download", handleSurveyDownload, null);
	};

	const handleSurveyDownload = async (download) => {

	  console.log(download);

	  // Clear existing data
	  await db.projects.clear();
	  await db.buildings.clear();
	  await db.floors.clear();
	  await db.workplaces.clear();
	  await db.workplaceTypes.clear();
	  await db.activities.clear();
	  await db.times.clear();

	  // Use a transaction (clean + safe)
	  await db.transaction('rw',
	    db.projects,
	    db.buildings,
	    db.floors,
	    db.workplaces,
	    db.workplaceTypes,
	    db.activities,
	    db.times,
	    async () => {

	      // Projects
	      if (download.surveyDownloadProjects) {
	        for (const code in download.surveyDownloadProjects) {
	          const project = download.surveyDownloadProjects[code];
	          await db.projects.put({
	            id: project.id,
	            code: project.code,
	            name: project.name,
	            description: project.description,
	            client: project.client,
	            type: project.type,
	            photo: project.photo
	          });
	        }
	      }

	      // Buildings
	      if (download.surveyDownloadBuildings) {
	        for (const code in download.surveyDownloadBuildings) {
	          const building = download.surveyDownloadBuildings[code];
	          await db.buildings.put({
	            id: building.id,
	            code: building.code,
	            name: building.name,
	            description: building.description,
	            photo: building.photo,
	            projectId: building.projectId
	          });
	        }
	      }

	      // Floors
	      if (download.surveyDownloadFloors) {
	        for (const code in download.surveyDownloadFloors) {
	          const floor = download.surveyDownloadFloors[code];
	          await db.floors.put({
	            id: floor.id,
	            code: floor.code,
	            name: floor.name,
	            description: floor.description,
	            dwg: floor.dwg,
	            width: floor.width,
	            height: floor.height,
	            buildingId: floor.buildingId,
	            displayCode: floor.displayCode
	          });
	        }
	      }

	      // Workplaces
	      if (download.surveyDownloadWorkplaces) {
	        for (const code in download.surveyDownloadWorkplaces) {
	          const workplace = download.surveyDownloadWorkplaces[code];
	          await db.workplaces.put({
	            id: workplace.id,
	            code: workplace.code,
	            name: workplace.name,
	            description: workplace.description,
	            workplaceTypeId: workplace.workplaceTypeId,
	            svg: workplace.svg,
	            floorId: workplace.floorId
	          });
	        }
	      }

	      // Workplace Types
	      if (download.surveyDownloadWorkplaceTypes) {
	        for (const code in download.surveyDownloadWorkplaceTypes) {
	          const workplaceType = download.surveyDownloadWorkplaceTypes[code];
	          await db.workplaceTypes.put({
	            id: workplaceType.id,
	            code: workplaceType.code,
	            name: workplaceType.name,
	            description: workplaceType.description,
	            multiOccupancy: workplaceType.multiOccupancy
	          });
	        }
	      }

	      // Activities
	      if (download.surveyDownloadActivities) {
	        for (const code in download.surveyDownloadActivities) {
	          const activity = download.surveyDownloadActivities[code];
	          await db.activities.put({
	            id: activity.id,
	            code: activity.code,
	            name: activity.name,
	            description: activity.description,
	            index: activity.index,
	            color: activity.color
	          });
	        }
	      }

	      // Times
	      if (download.surveyDownloadTimes) {
	        for (const sequence in download.surveyDownloadTimes) {
	          const time = download.surveyDownloadTimes[sequence];
	          await db.times.put({
	            id: time.id,
	            sequence: time.sequence,
	            hour: time.hour,
	            minute: time.minute
	          });
	        }
	      }

	    }
	  );

	  downloadComplete();
	};
	
	const goUpload = async () => {
  setDisplayDownloadInfo("flex");
  setDisplayDownloadProgress("flex");

  try {
    // fetch all processed but not uploaded rows
    const rows = (await db.utilisation.toArray());

    if (rows.length === 0) {
      alert("No data to upload.");
      setDisplayDownloadProgress("none");
      setDisplayDownloadInfo("none");
      return;
    }

    const jwt = localStorage.getItem(JWT);

    const response = await fetch("/resolutionsoftwareplatform/survey/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      },
      body: JSON.stringify(rows)
    });

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    // Mark uploaded
    await db.utilisation.bulkPut(
      rows.map(r => ({ ...r, uploaded: true }))
    );

    setDisplayDownloadProgress("none");
    setDisplayUploadComplete("flex");
    setTimeout(downloadComplete, 2000);
  } catch (err) {
    console.error("Upload error", err);
    alert("Upload failed, please retry later.");
    setDisplayDownloadInfo("none");
    setDisplayDownloadProgress("none");
  }
};



  const buttons = [
    { id: "1", title: "Download", icon: "download", color: "purple", clickFunction: goDownload },
    { id: "2", title: "Upload", icon: "cloud-arrow-up", color: "teal", clickFunction:goUpload }
  ];

  const buttonDisplay = buttons.map((item) => (
    <div style={buttonPanel} onClick={item.clickFunction} key={item.id}>
      <FontAwesomeIcon icon={item.icon} style={buttonIcon} />
      <div style={{ ...buttonColorBar, backgroundColor: item.color }} />
      <div style={buttonTitle}>{item.title}</div>
    </div>
  ));

  return (
    <div style={thisContainer}>
      <PageHeader title="Administration" />
      <LeftMenu />
      <div style={{ ...warningContainer, display: displayDownloadInfo }}>
        <div style={{ ...spinnerContainer, display: displayDownloadProgress }}>
          <CircularProgress color="inherit" size={100} />
        </div>
        <div style={{ ...warningPanel, display: displayDownloadComplete }}>
          <FontAwesomeIcon icon="check" style={{ ...warningIcon, color: "green" }} />
          <div style={warningText}>Download Complete!</div>
        </div>
		<div style={{ ...warningPanel, display: displayUploadComplete }}>
		          <FontAwesomeIcon icon="check" style={{ ...warningIcon, color: "green" }} />
		          <div style={warningText}>Upload Complete!</div>
		        </div>
      </div>
      
      <div style={buttonContainer}>{buttonDisplay}</div>
    </div>
  );
}
